import { render, staticRenderFns } from "./CompanyEditPage.vue?vue&type=template&id=f344acd0&"
import script from "./CompanyEditPage.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports